module.exports = {
  iterations: ($stateParams, Api) ->
    Api.WorkflowStepIteration.query( {project: $stateParams.projectId} ).$promise

  researchRequests: ($stateParams, Api) ->
    Api.ResearchRequest.query( {project: $stateParams.projectId} )
}
